import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ExternalSettings } from '../../../services/external-settings/external-settings.interface';
import { ExternalSettingsService } from '../../../services/external-settings/external-settings.service';
import { ResponsiveDesignService } from '../../../services/responsive-design/responsive-design.service';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';

export interface AppAuthenticatorWaitingDialogData {
  onStillNotGettingNotification: () => void;
}

@Component({
  selector: 'app-app-authenticator-waiting',
  templateUrl: './app-authenticator-waiting.component.html',
  styleUrls: ['./app-authenticator-waiting.component.less'],
  standalone: false,
})
export class AppAuthenticatorWaitingComponent implements OnInit {

  UIUtilityService: any = UIUtilityService;
  externalSettings!: ExternalSettings;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AppAuthenticatorWaitingDialogData,
    public dialogRef: MatDialogRef<AppAuthenticatorWaitingComponent, void>,
    private srvES: ExternalSettingsService,
    protected srvRpDesign: ResponsiveDesignService,
  ) { }

  ngOnInit(): void {
    this.srvES.externalSettings$.subscribe((settings) => {
      this.externalSettings = settings;
    });
  }

  onStillNotGettingNotification(): void {
    this.data.onStillNotGettingNotification?.();
  }
}
